/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sanction_Sa_No_RoundInputs */



/**
* | output |
* | --- |
* | "A Standings Adjustment needs at least one round played." |
*
* @param {Sanction_Sa_No_RoundInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const sanction_sa_no_round = /** @type {((inputs?: Sanction_Sa_No_RoundInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sanction_Sa_No_RoundInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Un Ajustement de Classement nécessite au moins une ronde jouée.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Un Ajuste de Clasificación requiere al menos una ronda jugada.")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Um Ajuste de Classificação exige pelo menos uma rodada jogada.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Un Aggiustamento di Classifica richiede almeno un round giocato.")
	return /** @type {LocalizedString} */ ("A Standings Adjustment needs at least one round played.")
});